function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P1Belt = function P1Belt(_ref) {
  var page = _ref.page;
  var thisPage = 0;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      $('.p1-belt').css({
        opacity: 1
      });
      setTimeArr([setTimeout(function () {
        $('.p1-belt__sm').addClass('p1-belt__sm--active');
      }, 1000), setTimeout(function () {
        $('.p1-belt__gravel').css({
          opacity: 1
        });
      }, 1500)]);
    } else {
      $('.p1-belt').css({
        opacity: 0
      });
      $('.p1-belt__gravel').css({
        opacity: 0
      });
      $('.p1-belt__sm').removeClass('p1-belt__sm--active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p1-belt"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p1/belt-lg.png",
    className: "p1-belt__lg"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p1/belt-sm.png",
    className: "p1-belt__sm"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p1/dirt@3x.png",
    className: "p1-belt__gravel"
  }));
};
export default P1Belt;